module.exports = __webpack_public_path__ + "static/media/Yoshi.78f1b903.gif";